import { render, staticRenderFns } from "./ProjectBurnChart.vue?vue&type=template&id=563124e3"
import script from "./ProjectBurnChart.vue?vue&type=script&lang=js"
export * from "./ProjectBurnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports